import { createFileRoute } from "@tanstack/react-router";

import HighlightsEditContent from "../-components/$categoryId.$highlightId";

export const Route = createFileRoute(
  "/_authenticated/$alias/settings/highlights/$categoryId/$highlightId",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { categoryId, highlightId } = Route.useParams();
  return <HighlightsEditContent categoryId={categoryId} highlightId={highlightId} />;
}
